import React from 'react';

import styles from 'bloko/blocks/radio/radio.less';

const RadioOpeningContent: React.FC<JSX.IntrinsicElements['span'] & React.PropsWithChildren> = (props) => (
    <span {...props} className={styles['bloko-radio__opening-content']} />
);

export default RadioOpeningContent;
